/*global google*/
/*eslint no-undef: "error"*/

import React, {Component} from 'react';

const DEFAULT_MAP_CONFIG = {
    center: {lat: 38.826557, lng: -96.111918},
    zoom: 5
};


class GoogleHeatMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            map: null,
            markers: null,
            openWindow: null
        }
    }

    componentDidMount() {
        if (!window.initHeatMap) {
            window.initHeatMap = this.initMap;
            const script = document.createElement("script");
            script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCSvWkVdrGsFpOsrnvCLVFZWpGgtGbrVRw&libraries=visualization&callback=initHeatMap";
            script.async = true;
            document.body.appendChild(script);
        } else {
            this.initMap();
        }

        this.props.data.forEach(item => {
            // console.log("item", item);
            if (!item.lat) {
                console.log("WHAT DA CRUNK", item);
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (this.state.heatmap) {
            this.state.heatmap.setData(this.props.data.map(item => new google.maps.LatLng(item.lat, item.lng)))
        }
    }

    initMap = () => {
        let config = {...DEFAULT_MAP_CONFIG};
        let map = new google.maps.Map(document.getElementById('map'), config);
        let heatmap = new google.maps.visualization.HeatmapLayer({
            data: this.props.data.map(item => new google.maps.LatLng(item.lat, item.lng)),
            map: map,
            radius: 20
        });

        this.setState({
            map,
            heatmap
        });
    };

    render() {
        return (
            <div id="map" style={{position: "absolute", top: 0, right: 0, left: 0, bottom: 0}}>
            </div>
        );
    }
}

export default GoogleHeatMap;



// WEBPACK FOOTER //
// ./src/components/google-heat-map/index.js